<span class="env-badge" [ngClass]="env === 'DEV' ? 'env-badge--dev' : 'env-badge--qa'">
  {{ env }}
</span>
